// Spanish formatting, ported from the prototype. Intl 'es-ES' is not used: it prints 1000 (not 1.000) and '-' instead of '−'.
export function fmtN(x: number | null | undefined, dec: number): string {
  if (x == null || isNaN(x)) return '—';
  const s = Math.abs(x).toFixed(dec); const neg = x < 0 && Number(s) !== 0;
  let [i, f] = s.split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return (neg ? '−' : '') + i + (f ? ',' + f : '');
}
export const fmtEur = (x: number | null | undefined): string => fmtN(x, 2) + ' €';
export const fmtPct = (x: number, sign?: boolean): string => { const s = fmtN(x * 100, 2); return (sign && Number((x * 100).toFixed(2)) > 0 ? '+' : '') + s + ' %'; };
export function fmtUnits(x: number | null | undefined, max?: number): string {
  if (x == null) return '—';
  let s = fmtN(x, max == null ? 8 : max); if (s.indexOf(',') >= 0) s = s.replace(/0+$/, '').replace(/,$/, ''); return s;
}
export function fmtDate(d: string | null | undefined): string { if (!d) return '—'; const [y, m, dd] = d.split('-'); return dd + '/' + m + '/' + y; }
export const fmtCcy = (x: number, ccy: string): string => fmtN(x, 2) + ' ' + ccy;
/**
 * Parses Spanish user input: a comma marks decimals and dots group thousands ("1.000" is 1000, "1.000,50" is 1000.5).
 * Without a comma, a dot that does not group thousands is decimal ("0.5", "1.5"). The prototype read "1.000" as 1; changed
 * on purpose on 22 Oct 2026, because prices in KRW or INR make such numbers common.
 */
export function parseNum(input: unknown): number {
  let s = String(input || '').trim().replace(/\s/g, ''); if (!s) return NaN;
  if (/^-?[1-9]\d{0,2}(\.\d{3})+(,\d*)?$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
  else if (s.indexOf(',') >= 0) { if (s.indexOf('.') >= 0) return NaN; s = s.replace(',', '.'); }
  return /^-?\d*\.?\d*$/.test(s) ? parseFloat(s) : NaN;
}
